/**
 * Single source of truth for "which route does this user land on by default
 * after auth?" Used by login.tsx, auth/callback.tsx, DashboardRedirect.tsx,
 * and register.tsx so every post-auth navigation point agrees.
 *
 * Without this, multiple call sites re-derive the role from `user.roles` in
 * subtly different ways. The original "split brain" bug 1AC21B was caused by
 * login.tsx picking `roles[0]` (array order) while the Shell sidebar picked
 * the highest-priority role — a staff user with `['CUSTOMER', 'COMPLIANCE']`
 * landed on /accounts/me with a compliance sidebar.
 *
 * Priority order (highest first):
 *   SUPER_ADMIN / ADMIN → CM dashboard with All TX preselected (panopticon)
 *   COMPLIANCE         → Compliance dashboard
 *   CASE_MANAGER       → CM dashboard
 *   OPERATIONS         → All Transactions lookup surface
 *   CUSTOMER (or no recognized role) → /accounts/me
 *
 * Mirrors the backend's getHighestRole() in graphql-svc/src/constants/roles.ts
 * by ordering; absolute priority numbers differ across the Lambda boundary but
 * the ordering agrees.
 */
export function getDefaultRouteForRoles(roles: string[] = []): string {
  if (roles.includes('SUPER_ADMIN') || roles.includes('ADMIN')) {
    return '/case-manager/dashboard?lane=all-tx';
  }
  if (roles.includes('COMPLIANCE')) {
    return '/compliance/dashboard';
  }
  if (roles.includes('CASE_MANAGER')) {
    return '/case-manager/dashboard';
  }
  if (roles.includes('OPERATIONS')) {
    return '/admin/transactions';
  }
  return '/accounts/me';
}
